module.exports = __webpack_public_path__ + "img/pic_162913.88d494e2.jpg";